<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        

        <!-- SIDEBAR -->
        <SidebarBody/>

        

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>
            
            

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" >

                <div class="row mb-32 gy-32 dash-top">

                    <div class="col-12">

                        
                        <div class="row g-32">

                            

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>
                                
                                

                                <div class="row g-32">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-body">
                                                <h3 style="text-align: center;" class="mm-none">Subscription Bundles</h3>
                                                <p class="hp-p1-body">Set prices for your subscription bundles. This feature is only available for verified models. Regular users can only post free content.</p>

                                                <div class="divider mt-18 mb-16"></div>

                                                <div class="col-12 mt-32" v-if="userType == 'model'">
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="ri-lock-unlock-line hp-text-color-dark-0 me-16"
                                                                        style="font-size: 24px;"></i>

                                                                    <div>
                                                                        <h5 class="mb-0">Free</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            All your posts will be free for users to view. Your pay per view (PPV) posts will still remain locked</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Make your posts free.</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="form-check form-switch"  @click="setProfileType">
                                                                    <input class="form-check-input" type="checkbox" id="typeInput" checked v-if="profileType == 'free'">
                                                                    <input class="form-check-input" type="checkbox" id="typeInput" v-else>
                                                                    <label class="form-check-label" for="typeInput" v-if="profileType == 'free'">

                                                                    </label>
                                                                    <label class="form-check-label" for="typeInput" v-else>
                                                                        
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                <form @submit.prevent="confirm">

                                                    <div class="mb-24" style="margin-top: 50px;">

                                                        <label for="displayName" class="form-label">1 month bundle</label>
                                                        <div class="input-group mb-16">
                                                            <span class="input-group-text" id="basic-addon1">&#8358;</span>

                                                            <input type="number" class="form-control" placeholder="0.00 ~ Free" aria-label="Username" aria-describedby="basic-addon1" disabled v-if="userType == 'user'">

                                                            <input type="number" class="form-control" placeholder="0 to 50,000" aria-label="Username" aria-describedby="basic-addon1" required v-model="bundle1" v-else>

                                                            
                                                        </div>

                                                    </div>

                                                    <div class="mb-24" style="margin-top: 30px;">

                                                        <label for="displayName" class="form-label">3 months bundle</label>
                                                        <div class="input-group mb-16">
                                                            <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                                            <input type="number" class="form-control" placeholder="0.00 ~ Free" aria-label="Username" aria-describedby="basic-addon1" disabled v-if="userType == 'user'">

                                                            <input type="number" class="form-control" placeholder="0 to 50,000" aria-label="Username" aria-describedby="basic-addon1" required v-model="bundle2" v-else>
                                                        </div>

                                                    </div>

                                                    <div class="mb-24" style="margin-top: 30px;">

                                                        <label for="displayName" class="form-label">6 months bundle</label>
                                                        <div class="input-group mb-16">
                                                            <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                                            <input type="number" class="form-control" placeholder="0.00 ~ Free" aria-label="Username" aria-describedby="basic-addon1" disabled v-if="userType == 'user'">

                                                            <input type="number" class="form-control" placeholder="0 to 50,000" aria-label="Username" aria-describedby="basic-addon1" required v-model="bundle3" v-else>
                                                        </div>

                                                    </div>

                                                    <div class="mb-24" style="margin-top: 30px;" v-if="userType != 'user'">
                                                        <label for="exampleInputEmail1" class="form-label">Custom description text</label>
                                                        <textarea class="form-control" v-model="customText" cols="30" rows="4" maxlength="80" style="line-height: 200%;" placeholder="Write a description for your subscription page..."></textarea>

                                                    </div>

                                                    <div class="divider mt-18 mb-16"></div>

                                                    <div class="mb-24" style="margin-top: 50px; display: flex; justify-content: center;" v-if="userType != 'user'">

                                                        <button class="btn btn-primary" style="color: #ffffff;">Confirm</button>

                                                    </div>

                                                    

                                                </form>

                                                <div class="mb-24" style="margin-top: 50px; display: flex; justify-content: center;" v-if="userType == 'user'">

                                                    <button class="btn btn-primary" style="color: #ffffff;" @click="becomeModel">Become a model</button>

                                                </div>

                                                

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SETTINGS -->
                            <SettingsBody/>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>
    
    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import SettingsBody from '@/components/SettingsBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore"; 
    import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
    import {getAuth, onAuthStateChanged, signOut} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            SettingsBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText:"",
                errorText: "",
                successText: "",

                userType: "",
                bundle1: "",
                bundle2: "",
                bundle3: "",

                customText: "",
                profileType: "",
                spamCount: 0
            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Subscription Bundles';

            document.getElementById("moreN").classList.add("active");
            document.getElementById("moreN2").classList.add("active");
            
            this.getUserInfo();
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            async getUserInfo(){

                this.loadingText = "Getting user info...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    
                    this.userType = userSnap.data().type;
                    this.bundle1 = userSnap.data().bundle1;
                    this.bundle2 = userSnap.data().bundle2;
                    this.bundle3 = userSnap.data().bundle3;
                    this.customText = userSnap.data().subDescription;
                    this.profileType = userSnap.data().profileType;
                    
                }
                else{
                    this.$router.push({name: 'sign-in'});
                    return;
                }

                this.$refs.loadingModal.classList.remove("bg-active");

            },

            becomeModel(){
                this.$router.push({ name: 'kyc' });
            },

            async confirm(){

                this.loadingText = "Saving bundle prices...";
                this.$refs.loadingModal.classList.add("bg-active");

                if(this.bundle1 < 1000 || this.bundle2 < 1000 || this.bundle3 < 1000){
                    this.errorText = "The minimum price for all bundles is ₦ 1,000.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                if(this.bundle1 > 5000000 || this.bundle2 > 5000000 || this.bundle3 > 5000000){
                    this.errorText = "The maximum price for all bundles is ₦ 5,000,000.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                const auth = getAuth();

                const UserRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(UserRef, {
                    bundle1: this.bundle1,
                    bundle2: this.bundle2,
                    bundle3: this.bundle3,
                    subDescription: this.customText,
                });

                this.successText = "Bunlde prices were updated successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async setProfileType(){

                if(this.spamCount > 3){
                    return;
                }

                this.spamCount++;
                this.loadingText = "Saving settings...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                if(this.profileType == 'free'){

                    const UserRef = doc(db, "Users", auth.currentUser.uid);
                    await updateDoc(UserRef, {
                        profileType: "sub"
                    });

                    this.profileType = "sub";

                }

                else{

                    const UserRef = doc(db, "Users", auth.currentUser.uid);
                    await updateDoc(UserRef, {
                        profileType: "free"
                    });

                    this.profileType = "free";

                }

                this.successText = "Subscription settings was updated successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                
            }

        },
        
    }
</script>